
import React from 'react';

import { Card, CardActions, CardContent, Button, Avatar, Grid, Chip } from '@material-ui/core';


import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'

const ChallengeInfoPanel = ({
  challenge,
  classes,
  showDetails,
  expiresImg,
  visitImg,
  taggedImg,
  pendingImg,
  sponsorName,
  proposerEmail,
  proposerNameNotAvailable,
  proposedDate,
  challengeCreateDate,
  starts,
  ends,
  // endDate,
  visits,
  numIdeas,
  formatDate,

  navigateToUserProfile,
}) => {

  const ROUTES = NavigationService.getRoutes()
  const detailProfilePath = ROUTES[pages.PROFILE_PAGE_USER].path.replace(":email",proposerEmail);

// console.log("detailProfilePath.", detailProfilePath , proposerEmail, proposerNameNotAvailable)

  return (
    <div className={classes.infoPanel}>
      {showDetails ? (
        <>
          <div
            className={
              challenge.status === 'FINISHED1' || challenge.status === 'PROPOSED'
                ? classes.infoGrid2
                : classes.infoGrid
            }
          >
            {challenge.status !== 'PROPOSED' && (
              <div className={classes.infoPanelHeaders} >Expires on</div>
            )}
            {challenge.status !== 'FINISHED1' && (
              <div className={classes.infoPanelHeaders}>No. of visits</div>
            )}  
          {/* <div></div> */}
            <div className={classes.infoPanelHeaders}>Ideas tagged</div>

            {challenge.status !== 'PROPOSED' && (
              <div
                className={classes.infoPanelIcons}
                style={
                  challenge.status === 'FINISHED1'
                    ? { borderRight: '1px solid #EBEBEB' }
                    : null
                }
              >
                <img src={expiresImg} className={classes.icon_img} alt="icon" />
                <div className={classes.infoPanelNumber} >
                  {formatDate(ends?.dateString || ends)}
                </div>
              </div>
            )}

            {challenge.status !== 'FINISHED1' && (
              <div
                className={classes.infoPanelIcons}
                style={{ borderRight: '1px solid #EBEBEB' }}
              >
                <img src={visitImg} className={classes.icon_img} alt="icon" />
                <div className={classes.infoPanelNumber}>{visits}</div>
              </div>
            )}
            {/* <div></div> */}

            <div className={classes.infoPanelIcons}>
              <img src={taggedImg} className={classes.icon_img} alt="icon" />
              <div className={classes.infoPanelNumber}>{numIdeas}</div>
            </div>
          </div>

          {/* {challenge.status !== 'PROPOSED' && (
            <div className={classes.sponsoredSubmitted}>
              Sponsored by:{' '}
              <span className={classes.nameDateSpan}>{sponsorName}</span>
            </div>
          )} */}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '85px',
            marginBottom: '79px',
          }}
        >
          <img
            style={{ height: '44px' }}
            src={pendingImg}
            alt="pending icon"
          />
          <div className={classes.no_details_header}>Pending Review</div>
        </div>
      )}

      <div className={classes.sponsoredSubmitted}>
        Submitted by:{' '}
        <span className={classes.nameDateSpan}>
          {/* <button
            type="button"
            className={classes.btnBlank}
            onClick={() => navigateToUserProfile(proposerEmail)}
          >
            {proposerNameNotAvailable}
          </button> */}

         <a className={classes.btnBlank} href={detailProfilePath}>
         {proposerNameNotAvailable}
        </a>

        </span>{' '}
        on{' '}
        <span className={classes.nameDateSpan}>
          {proposedDate || formatDate( challengeCreateDate?.dateString || challengeCreateDate )}
        </span>
      </div>
    </div>
  );
};

export default ChallengeInfoPanel;